import { render, staticRenderFns } from "./ClaimReserve.vue?vue&type=template&id=285a7253&"
import script from "./ClaimReserve.vue?vue&type=script&lang=js&"
export * from "./ClaimReserve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports